var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"over-max-size-wrap",attrs:{"active":_vm.requestSize > _vm.maxSize}},[_vm._v(" "+_vm._s(_vm._f("translate")('용량 초과'))+" ("+_vm._s((_vm.requestSize / 1000000).toFixed(2))+"MB / "+_vm._s((_vm.maxSize / 1000000).toFixed(2))+"MB) ")])
}
var staticRenderFns = []

export { render, staticRenderFns }